<template>
  <div class="container-fluid" v-if="isEngraving">
    <template v-for="side in sides">
      <div class="row border-bottom" v-bind:key="side">
        <div
          class="col-12 text-start"
          style="cursor: pointer"
          @click="toggleCurrentEdit(side)"
        >
          <div class="row">
            <div class="col-9">
              <h5>{{ $t("Menu.list.engraving." + side) }}</h5>
            </div>
            <div class="col-3 text-end">
              <img
                :src="appUrl + '/img/icons/edit.svg'"
                class="icon open"
                style="margin-top: 0.5rem"
                v-if="currentEdit !== side"
                alt="edit"
              />
              <img
                :src="appUrl + '/img/icons/close.svg'"
                class="icon"
                style="margin-top: 0.5rem"
                v-else
                alt="close"
              />
            </div>
          </div>
          <div class="col-12" v-if="currentEdit !== side">
            <span
              v-if="
                currentItem.engraving[side].font < 1 &&
                currentItem.engraving[side].text === ''
              "
            >
              {{ $t("Menu.list.engraving.noEngraving") }}
            </span>
            <div
              v-else-if="
                currentItem.engraving[side].text !== '' &&
                currentItem.engraving[side].font > 0
              "
              class="preview-box"
              :style="{
                fontSize: '170%',
                backgroundImage: `url('${appUrl}/img/assets/engraving/bg_${side}_${getColorChar()}.png')`,
                backgroundPosition: `center 48%`,
                backgroundRepeat: `no-repeat`,
                margin: 'auto',
              }"
            >
              <div
                class="preview-text small"
                :ref="'preview-text-small-' + side"
                @scroll="onPreviewTextScroll"
                :class="getEngravingCssClass(currentItem.engraving[side].font)"
                v-html="generatePreview(currentItem.engraving[side].text)"
              ></div>
            </div>
            <div v-else>
              <p v-if="currentItem.engraving[side].font > 0">
                {{ getEngravingText(currentItem.engraving[side].font) }}
              </p>
              <p v-else>{{ currentItem.engraving[side].text }}</p>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="currentEdit === side">
          <h6>{{ $t("Menu.list.engraving.preview") }}</h6>
          <fieldset>
            <div
              class="preview-box"
              :style="{
                fontSize: '150%',
                backgroundImage: `url('${appUrl}/img/assets/engraving/bg_${side}_${getColorChar()}.png')`,
                backgroundPosition: `center 48%`,
                backgroundRepeat: `no-repeat`,
                margin: 'auto',
              }"
            >
              <div
                class="preview-text"
                :ref="'preview-text-' + side"
                @scroll="onPreviewTextScroll"
                :class="'font-' + currentItem.engraving[side].font"
                v-html="generatePreview(currentItem.engraving[side].text)"
              ></div>
            </div>
          </fieldset>

          <h6>{{ $t("Menu.list.engraving.wishtext") }}</h6>
          <fieldset class="form-group">
            <input
              type="text"
              maxlength="150"
              class="form-control"
              v-model="currentItem.engraving[side].text"
              @change="changeEngraving('text')"
              :id="'engraving-' + side"
            />
          </fieldset>

          <h6>{{ $t("Menu.list.engraving.font") }}</h6>
          <fieldset class="form-group">
            <div v-if="!fontPreview" class="font-selection">
              <div class="col-10 text-start" @click="fontPreview = true">
                <p v-if="currentItem.engraving[side].font > 0">
                  {{ getEngravingText(currentItem.engraving[side].font) }}
                </p>
                <p v-else>
                  {{ $t("Set.Item.Description.engraving.noEngraving") }}
                </p>
              </div>
              <div class="col-2 text-end">
                <img
                  :src="appUrl + '/img/icons/edit.svg'"
                  class="icon"
                  @click="fontPreview = true"
                  alt="edit"
                />
              </div>
            </div>
            <div v-if="fontPreview" class="font-selection-list">
              <img
                :src="appUrl + '/img/icons/close.svg'"
                class="icon"
                @click="fontPreview = false"
                alt="close"
              />
              <div
                class="preview-box font-preview"
                :class="{ on: currentItem.engraving[side].font < 1 }"
                @click="
                  currentItem.engraving[side].font = 0;
                  fontPreview = false;
                  changeEngraving('font');
                "
              >
                <div class="preview-text">
                  {{ $t("Set.Item.Description.engraving.noEngraving") }}
                </div>
              </div>
              <div
                v-for="fontType in engravingFonts"
                :key="'preview-' + parseInt(fontType[0])"
              >
                <div
                  class="preview-box font-preview"
                  :class="{
                    on:
                      currentItem.engraving[side].font == parseInt(fontType[0]),
                  }"
                  @click="
                    currentItem.engraving[side].font = parseInt(fontType[0]);
                    fontPreview = false;
                    changeEngraving('font');
                  "
                >
                  <div
                    class="preview-text"
                    :class="'font-' + parseInt(fontType[0])"
                    v-html="
                      generatePreview(
                        currentItem.engraving[side].text === '' ||
                          isNoFont[side][fontType[0]]
                          ? fontType[1]
                          : currentItem.engraving[side].text
                      )
                    "
                  ></div>
                  <p v-if="!isNoFont[side][fontType[0]]">{{ fontType[1] }}</p>
                </div>
              </div>
            </div>
          </fieldset>

          <h6>{{ $t("Menu.list.engraving.insertSymbol") }}</h6>
          <fieldset class="form-group">
            <ul class="symbols">
              <li v-for="symbol in symbols" v-bind:key="symbol">
                <img
                  :src="appUrl + '/engraving/symbols/' + symbol + '.svg'"
                  @click="addSymbol(side, symbol)"
                  alt="symbol"
                />
              </li>
            </ul>
          </fieldset>
        </div>
      </div>
    </template>
  </div>
  <div class="container-fluid" v-else>
    <div class="row">
      <div class="col-12 text-start">
        <p>{{ $t("Set.Item.Description.engraving.hint") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import Engraving from "@/vuex/Engraving";
import Config from "@/vuex/Config";
import EngravingSimulator from "../../../public/js/EngravingSimulator";

export default {
  name: "Engraving",
  props: ["currentItem"],
  data() {
    return {
      sides: ["inside", "outside"],
      currentEdit: "inside",
      fontPreview: false,
      jewelleryType: 0,
      appUrl: Config.getters.getAppUrl,
      symbols: [
        "S01",
        "S02",
        "S03",
        "S04",
        "S05",
        "S06",
        "S07",
        "S08",
        "S09",
        "S10",
        "S11",
        "S12",
        "S13",
        "S14",
      ],
      isNoFont: Engraving.getters.getNoFonts(),
    };
  },
  mounted() {
    EngravingSimulator.setAppUrl(this.appUrl);

    this.$root.$on("setJewelleryTypeForEngraving", () => {
      this.setJewelleryType();
    });

    this.updateAllPreviewTextAlignments();
    window.addEventListener("resize", this.updateAllPreviewTextAlignments);
  },
  updated() {
    this.updateAllPreviewTextAlignments();
  },
  beforeDestroy() {
    this.$root.$off("setJewelleryTypeForEngraving");
    window.removeEventListener("resize", this.updateAllPreviewTextAlignments);
  },
  methods: {
    onPreviewTextScroll: function (event) {
      this.updatePreviewTextAlignment(event.target);
    },
    updatePreviewTextAlignment: function (el) {
      if (!el) {
        return;
      }

      const hasOverflow =
        el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
      el.style.justifyContent = hasOverflow ? "start" : "center";
    },
    updateAllPreviewTextAlignments: function () {
      this.$nextTick(() => {
        const previewTextNodes = this.$el
          ? this.$el.querySelectorAll(".preview-text")
          : [];

        previewTextNodes.forEach((node) => {
          this.updatePreviewTextAlignment(node);
        });
      });
    },
    getColorChar: function () {
      let colorChar = "w";
      if (this.currentItem) {
        let itemnumber = this.currentItem.itemnumber;
        let itemParts = itemnumber.split("-");
        if (itemParts[2] && itemParts[2].length > 0) {
          // Extract color chars from item number
          let colorCharTmp = itemParts[2].charAt(0);
          let colorCharString = itemParts[2]
            .substring(0, itemParts[2].length - 1)
            .toLowerCase();

          // Get color char with most occurrences
          let colorChars = colorCharString.split("");
          if (colorChars.length > 0) {
            let colorCharsList = {};
            for (let i = 0; i < colorChars.length; i++) {
              if (!colorCharsList[colorChars[i]]) {
                colorCharsList[colorChars[i]] = 0;
              }
              colorCharsList[colorChars[i]]++;
            }
            const colorCharsSorted = Object.fromEntries(
              Object.entries(colorCharsList).sort(([, a], [, b]) => b - a)
            );
            colorCharTmp = Object.keys(colorCharsSorted)[0];
          }

          // Set color char
          if (
            colorCharTmp === "d" ||
            colorCharTmp === "e" ||
            colorCharTmp === "g" ||
            colorCharTmp === "h" ||
            colorCharTmp === "k" ||
            colorCharTmp === "r" ||
            colorCharTmp === "w" ||
            colorCharTmp === "x"
          ) {
            colorChar = colorCharTmp;
          }
        }
      }
      return colorChar;
    },
    setJewelleryType: function () {
      if (
        typeof this.$parent.$parent.$parent["getJewelleryType"] === "function"
      ) {
        this.jewelleryType = parseInt(
          this.$parent.$parent.$parent["getJewelleryType"]()
        );
      }
    },
    toggleCurrentEdit: function (id) {
      this.currentEdit = this.currentEdit === id ? "" : id;
    },
    changeEngraving: function (type) {
      if (
        type === "text" &&
        this.currentItem.engraving[this.currentEdit].text !== "" &&
        this.currentItem.engraving[this.currentEdit].font < 1
      ) {
        this.currentItem.engraving[this.currentEdit].font =
          this.currentEdit === "inside" ? 4 : 91;
      } else if (
        type === "font" &&
        this.currentItem.engraving[this.currentEdit].text !== "" &&
        this.currentItem.engraving[this.currentEdit].font < 1
      ) {
        this.currentItem.engraving[this.currentEdit].text = "";
      }

      SetData.dispatch("setItemEngraving", this.currentItem.engraving).then(
        () => {
          this.$parent.$parent.$parent.$parent["reset3d"](true);
        }
      );
    },
    getEngravingText: function (fontId) {
      return Engraving.getters.getFontTextById(fontId);
    },
    generatePreview: function (text) {
      return EngravingSimulator.getAsHtml(text);
    },
    getEngravingCssClass: function (fontId) {
      return EngravingSimulator.getCssClassByFontId(fontId);
    },
    addSymbol: function (side, symbolId) {
      let inputId =
        side === "inside" ? "engraving-inside" : "engraving-outside";

      let inputNode = document.getElementById(inputId);
      let cursorPos = inputNode.selectionStart;

      symbolId = "#" + symbolId;

      inputNode.value =
        inputNode.value.substr(0, cursorPos) +
        " " +
        symbolId +
        " " +
        inputNode.value.substr(cursorPos, inputNode.value.length);

      inputNode.value = inputNode.value.replace(/[ ]+/g, " ");

      inputNode.focus();

      this.currentItem.engraving[side].text = inputNode.value;
      this.changeEngraving("text");
    },
  },
  computed: {
    isEngraving: function () {
      if (
        parseInt(this.currentItem.description["plineId"]) === 479 ||
        parseInt(this.currentItem.description["plineId"]) === 564
      ) {
        return false;
      }

      return (
        this.jewelleryType === 0 ||
        this.jewelleryType === 2 ||
        this.jewelleryType === 3 ||
        this.jewelleryType === 6
      );
    },
    engravingFonts: function () {
      let fontList = [];

      if (parseInt(this.currentItem.description.jewelleryType) > 0) {
        fontList = Engraving.getters.getJewelleryList(this.currentEdit);
      } else {
        fontList = Engraving.getters.getStandardList(this.currentEdit);
      }

      fontList = Object.entries(fontList).sort((a, b) => {
        if (b[1] > a[1]) return -1;
        else if (b[1] < a[1]) return 1;
      });

      return fontList;
    },
    engravingInside: function () {
      return this.generatePreview(this.currentItem.engraving.inside.text);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  h6 {
    margin-top: 2rem;
  }

  .preview-box {
    display: flex;
    //background-color: $lightGreyBg;
    justify-content: center;
    line-height: 6rem;

    @media (min-width: 1280px) {
      width: 60rem;
    }

    .preview-text {
      display: flex;
      align-items: center;
      padding: 0 0.5rem;
      justify-content: center;
      width: 44rem;
      font-size: 1.25em;
      overflow: auto;
      white-space: nowrap;
      height: 10rem;

      @media (min-width: 768px) {
        font-size: 1.5em;
      }

      img {
        display: inline;
        height: 1.5em !important;
      }
    }

    p {
      display: flex;
      justify-content: flex-end;
      text-align: right;
      align-items: center;
      margin: 0 0.75rem 0 0;
      width: 100%;
      font-size: 0.8em;
      line-height: 1.25em;
      padding-bottom: 0.5em;
      border-bottom: solid 0.1em $lightGreyBg;

      @media (min-width: 768px) {
        font-size: 1.25em;
      }
    }
  }

  .preview-box.font-preview {
    background-color: white;
    cursor: pointer;
  }

  .preview-box.on,
  .preview-box:hover {
    background-color: $lightGreyBg;
  }

  .font-selection {
    display: flex;
    border: solid 0.1rem $lightGreyBg;
    height: 3em;
    cursor: pointer;

    .icon {
      margin: 0.6em 0 0.5em 1.5em;
    }

    p {
      line-height: 3em;
    }
  }

  .font-selection-list {
    border: solid 0.1rem $lightGreyBg;
    width: 100%;
    padding: 0.5em;
    position: relative;

    .preview-box {
      width: 90%;
    }

    .icon {
      position: absolute;
      right: 0.5em;
      top: 0.5em;
      margin: 0;
    }
  }

  ul.symbols {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      list-style: none;
      padding: 1em;
      width: 5.5em;
      text-align: center;
      cursor: pointer;

      img {
        height: 1.8em;
      }
    }
  }
}
</style>
